/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PageUsersDTO,
  PagedModelUsersDTO,
  PatchDocument,
  UsersDTO,
} from '../models/index';
import {
    PageUsersDTOFromJSON,
    PageUsersDTOToJSON,
    PagedModelUsersDTOFromJSON,
    PagedModelUsersDTOToJSON,
    PatchDocumentFromJSON,
    PatchDocumentToJSON,
    UsersDTOFromJSON,
    UsersDTOToJSON,
} from '../models/index';

export interface CreateUserRequest {
    usersDTO: UsersDTO;
}

export interface DeleteUserRequest {
    id: number;
}

export interface FindAllWithFailedOrcidConnectionByInstitutionRequest {
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface FindAllWithOrcidIdRequest {
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface FindAllWithValidOrcidConnectionByInstitutionRequest {
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface FindOneWithOrcidIdByNameRequest {
    searchParameter: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface GetExternUserByUsernameRequest {
    username: string;
}

export interface GetUserRequest {
    id: number;
}

export interface GetUserByOrcidIDRequest {
    orcidId: string;
}

export interface GetUsersRequest {
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface GetUsersByIdsRequest {
    userIds: Array<number>;
}

export interface PatchUserRequest {
    id: number;
    patchDocument?: Array<PatchDocument>;
}

export interface SearchUserRequest {
    searchParameter: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface SearchUserWithFailedOrcidRequest {
    searchParameter: string;
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

export interface SearchUserWithValidOrcidRequest {
    searchParameter: string;
    institution: string;
    page?: number;
    size?: number;
    sort?: string;
    direction?: string;
}

/**
 * 
 */
export class UsersServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createUser without sending the request
     */
    async createUserRequestOpts(requestParameters: CreateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersDTO'] == null) {
            throw new runtime.RequiredError(
                'usersDTO',
                'Required parameter "usersDTO" was null or undefined when calling createUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UsersDTOToJSON(requestParameters['usersDTO']),
        };
    }

    /**
     */
    async createUserRaw(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersDTO>> {
        const requestOptions = await this.createUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async createUser(requestParameters: CreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersDTO> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteUser without sending the request
     */
    async deleteUserRequestOpts(requestParameters: DeleteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for findAllWithFailedOrcidConnectionByInstitution without sending the request
     */
    async findAllWithFailedOrcidConnectionByInstitutionRequestOpts(requestParameters: FindAllWithFailedOrcidConnectionByInstitutionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling findAllWithFailedOrcidConnectionByInstitution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['institution'] != null) {
            queryParameters['institution'] = requestParameters['institution'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findAllWithFailedOrcidConnectionByInstitution`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findAllWithFailedOrcidConnectionByInstitutionRaw(requestParameters: FindAllWithFailedOrcidConnectionByInstitutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.findAllWithFailedOrcidConnectionByInstitutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithFailedOrcidConnectionByInstitution(requestParameters: FindAllWithFailedOrcidConnectionByInstitutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.findAllWithFailedOrcidConnectionByInstitutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllWithOrcidId without sending the request
     */
    async findAllWithOrcidIdRequestOpts(requestParameters: FindAllWithOrcidIdRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findAllWithOrcidId`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findAllWithOrcidIdRaw(requestParameters: FindAllWithOrcidIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.findAllWithOrcidIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithOrcidId(requestParameters: FindAllWithOrcidIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.findAllWithOrcidIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllWithValidOrcidConnectionByInstitution without sending the request
     */
    async findAllWithValidOrcidConnectionByInstitutionRequestOpts(requestParameters: FindAllWithValidOrcidConnectionByInstitutionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling findAllWithValidOrcidConnectionByInstitution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['institution'] != null) {
            queryParameters['institution'] = requestParameters['institution'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findAllWithValidOrcidConnectionByInstitution`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findAllWithValidOrcidConnectionByInstitutionRaw(requestParameters: FindAllWithValidOrcidConnectionByInstitutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.findAllWithValidOrcidConnectionByInstitutionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findAllWithValidOrcidConnectionByInstitution(requestParameters: FindAllWithValidOrcidConnectionByInstitutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.findAllWithValidOrcidConnectionByInstitutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findOneWithOrcidIdByName without sending the request
     */
    async findOneWithOrcidIdByNameRequestOpts(requestParameters: FindOneWithOrcidIdByNameRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchParameter'] == null) {
            throw new runtime.RequiredError(
                'searchParameter',
                'Required parameter "searchParameter" was null or undefined when calling findOneWithOrcidIdByName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['searchParameter'] != null) {
            queryParameters['searchParameter'] = requestParameters['searchParameter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findOneWithOrcidIdByName`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findOneWithOrcidIdByNameRaw(requestParameters: FindOneWithOrcidIdByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.findOneWithOrcidIdByNameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async findOneWithOrcidIdByName(requestParameters: FindOneWithOrcidIdByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.findOneWithOrcidIdByNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getExternUserByUsername without sending the request
     */
    async getExternUserByUsernameRequestOpts(requestParameters: GetExternUserByUsernameRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling getExternUserByUsername().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['username'] != null) {
            queryParameters['username'] = requestParameters['username'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findOneByUsername`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getExternUserByUsernameRaw(requestParameters: GetExternUserByUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersDTO>> {
        const requestOptions = await this.getExternUserByUsernameRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getExternUserByUsername(requestParameters: GetExternUserByUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersDTO> {
        const response = await this.getExternUserByUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUser without sending the request
     */
    async getUserRequestOpts(requestParameters: GetUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUserRaw(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersDTO>> {
        const requestOptions = await this.getUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUser(requestParameters: GetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersDTO> {
        const response = await this.getUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUserByOrcidID without sending the request
     */
    async getUserByOrcidIDRequestOpts(requestParameters: GetUserByOrcidIDRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling getUserByOrcidID().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orcidId'] != null) {
            queryParameters['orcidId'] = requestParameters['orcidId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/findOneByOrcidId`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUserByOrcidIDRaw(requestParameters: GetUserByOrcidIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersDTO>> {
        const requestOptions = await this.getUserByOrcidIDRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUserByOrcidID(requestParameters: GetUserByOrcidIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersDTO> {
        const response = await this.getUserByOrcidIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUsers without sending the request
     */
    async getUsersRequestOpts(requestParameters: GetUsersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUsersRaw(requestParameters: GetUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageUsersDTO>> {
        const requestOptions = await this.getUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async getUsers(requestParameters: GetUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageUsersDTO> {
        const response = await this.getUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUsersByIds without sending the request
     */
    async getUsersByIdsRequestOpts(requestParameters: GetUsersByIdsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userIds'] == null) {
            throw new runtime.RequiredError(
                'userIds',
                'Required parameter "userIds" was null or undefined when calling getUsersByIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userIds'] != null) {
            queryParameters['userIds'] = requestParameters['userIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/getUsersByIds`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUsersByIdsRaw(requestParameters: GetUsersByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: UsersDTO; }>> {
        const requestOptions = await this.getUsersByIdsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, UsersDTOFromJSON));
    }

    /**
     */
    async getUsersByIds(requestParameters: GetUsersByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: UsersDTO; }> {
        const response = await this.getUsersByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchUser without sending the request
     */
    async patchUserRequestOpts(requestParameters: PatchUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling patchUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['patchDocument']!.map(PatchDocumentToJSON),
        };
    }

    /**
     */
    async patchUserRaw(requestParameters: PatchUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersDTO>> {
        const requestOptions = await this.patchUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async patchUser(requestParameters: PatchUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersDTO> {
        const response = await this.patchUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchUser without sending the request
     */
    async searchUserRequestOpts(requestParameters: SearchUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchParameter'] == null) {
            throw new runtime.RequiredError(
                'searchParameter',
                'Required parameter "searchParameter" was null or undefined when calling searchUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['searchParameter'] != null) {
            queryParameters['searchParameter'] = requestParameters['searchParameter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchUserRaw(requestParameters: SearchUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.searchUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUser(requestParameters: SearchUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.searchUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchUserWithFailedOrcid without sending the request
     */
    async searchUserWithFailedOrcidRequestOpts(requestParameters: SearchUserWithFailedOrcidRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchParameter'] == null) {
            throw new runtime.RequiredError(
                'searchParameter',
                'Required parameter "searchParameter" was null or undefined when calling searchUserWithFailedOrcid().'
            );
        }

        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling searchUserWithFailedOrcid().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['searchParameter'] != null) {
            queryParameters['searchParameter'] = requestParameters['searchParameter'];
        }

        if (requestParameters['institution'] != null) {
            queryParameters['institution'] = requestParameters['institution'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/searchUserWithFailedOrcid`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchUserWithFailedOrcidRaw(requestParameters: SearchUserWithFailedOrcidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.searchUserWithFailedOrcidRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUserWithFailedOrcid(requestParameters: SearchUserWithFailedOrcidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.searchUserWithFailedOrcidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchUserWithValidOrcid without sending the request
     */
    async searchUserWithValidOrcidRequestOpts(requestParameters: SearchUserWithValidOrcidRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchParameter'] == null) {
            throw new runtime.RequiredError(
                'searchParameter',
                'Required parameter "searchParameter" was null or undefined when calling searchUserWithValidOrcid().'
            );
        }

        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling searchUserWithValidOrcid().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        if (requestParameters['searchParameter'] != null) {
            queryParameters['searchParameter'] = requestParameters['searchParameter'];
        }

        if (requestParameters['institution'] != null) {
            queryParameters['institution'] = requestParameters['institution'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/user/searchUserWithValidOrcid`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchUserWithValidOrcidRaw(requestParameters: SearchUserWithValidOrcidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedModelUsersDTO>> {
        const requestOptions = await this.searchUserWithValidOrcidRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedModelUsersDTOFromJSON(jsonValue));
    }

    /**
     */
    async searchUserWithValidOrcid(requestParameters: SearchUserWithValidOrcidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedModelUsersDTO> {
        const response = await this.searchUserWithValidOrcidRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
